import React from 'react';
import { ItemSection, ItemData } from './ItemSection';
const data: ItemData = {
  number: 4,
  title: 'Chlorine and Hard Minerals Interact, Creating Compounding Damage (Not Just Side-By-Side Irritation)',
  mechanism: <>
      This is critical: chlorine and hard minerals don't just cause separate
      damage—they <strong data-id="element-148">interact and worsen each other</strong>. Hard water
      reduces soap effectiveness, so parents bathe longer or use more soap. More
      soap + hard minerals = more soap scale. Simultaneously, chlorine vaporizes
      and disrupts pH. The combination creates a{' '}
      <strong data-id="element-149">multiplicative effect</strong>: the problems{' '}
      <strong data-id="element-150">reinforce each other</strong>. By day 7 of bathing in untreated
      water, the skin barrier damage is <strong data-id="element-151">compounding, not linear</strong>
      .
    </>,
  avatars: {
    jessica: <>
        This is why trying 'better products' <strong data-id="element-152">doesn't work</strong>.
        You're adding to the problem (more soap = more soap scale reaction)
        rather than solving it.
      </>,
    michelle: <>
        This interaction is why a single-solution approach (creams OR diet OR
        filters) <strong data-id="element-153">fails</strong>. The mechanism requires addressing{' '}
        <strong data-id="element-154">multiple variables simultaneously</strong>.
      </>
  },
  bridge: <>
      Creams work on the surface, but they{' '}
      <strong data-id="element-155">can't address the interaction</strong> happening at the{' '}
      <strong data-id="element-156">chemical level</strong> in the water itself.
    </>,
  image: {
    url: 'https://images.unsplash.com/photo-1507413245164-6160d8298b31?w=800&q=80',
    alt: 'Scientific cascade diagram showing domino-like progression of damage with teal and orange colors representing chlorine and minerals interacting and reinforcing each other'
  },
  imageOnLeft: true,
  bgColor: 'bg-gradient-to-b from-white to-brand-cream',
  borderBottom: 'border-brand-goldLight'
};
export function Item4Section() {
  return <ItemSection data={data} data-id="element-157" />;
}